// Note: Keep this list and ordering in sync with the LineStatus in the C# file
export enum LineStatus {
  Open,
  Pending,
  Watermarking,
  Transcoding,
  Encrypting,
  Packaging,
  Authoring,
  PinPlay,
  Licensing,
  Burning,
  PendingDownload,
  Uploading,
  IngestingMetadata,
  Complete,
  Cancelled,
  PendingShipped,
  Shipped,
  PostedOrClosed,
  All
}
